import { BaseAPI } from "@utils/base-api";
import {
  StripeCheckoutSessionDataDto,
} from "@./types/payment-methods/dto/stripe-checkout-session-data.dto";
import {
  StripeCheckoutCreateRequestDto,
} from "@./types/payment-methods/dto/stripe-checkout-create-request.dto";
import { PaymentMethodsCustomer } from "./types/payment-method-customer";

export interface HasNibblesRecentlyResponse {
  hasPurchasedNibbles: boolean;
  lastOrderDate: string | null;
}

export class PaymentMethodsAPI extends BaseAPI {

  public async getAllPaymentMethods(): Promise<PaymentMethodsCustomer> {
    const result = await this.axios.get<PaymentMethodsCustomer>(
      "/customer/payment-method/all",
    );
    return result.data;
  }

  public async updatePaymentMethods(
    request?: StripeCheckoutCreateRequestDto,
  ): Promise<StripeCheckoutSessionDataDto> {
    const result = await this.axios.post<StripeCheckoutSessionDataDto>(
      "/customer/stripe-checkout/update-card-details",
      request,
    );
    return result.data;
  }

  public async deletePaymentMethod(paymentMethodId: number): Promise<void> {
    await this.axios.delete(`/customer/payment-method/${paymentMethodId}`);
  }

}
